import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";
import { BeatLoader } from 'react-spinners';
import {
    deleteRequest,
    putRequest,
    postRequest,
    putRequestForm,
    RBButton,
    deleteConfirmationWords,
    ImageFileUpload,
    postRequestForm,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";

import Lightbox from "react-image-lightbox";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationPicker from "react-location-picker";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";


export default function InquiryReplyViewMode() {
    const _id = useParams();
    const location = useLocation();
    const state = location.state?.row;
    console.log(state);
    const [userAllDetails, setuserAllDetails] = useState({});
    const [ticket, setuserTicketData] = useState({});
    const [loader, setLoader] = useState(false);
    const [imageLB, setImage] = React.useState("");
    const [images, setImages] = React.useState([]);
    const [openLightbox, setOpenLightBox] = React.useState(false);

    const useStyles = makeStyles({
        tableHeader: {
            color: "#ffffff", // Use your preferred color
            backgroundColor: "#3f51b5", // Header background color
            fontWeight: "bold",
        },
        descriptionText: {
            fontSize: "0.8rem",
        },
        deleteIcon: {
            color: "red",
        },
        roundImage: {
            borderRadius: "50%",
            width: "75px",
            height: "75px",
        },
        roundImageSm: {
            borderRadius: "50%",
        },

        gridList: {
            width: "100%",
        },
        icon: {
            color: "rgba(255, 55, 25, 0.54)",
        },
    });

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const showLightBox = (image) => {
        setImage(image);
        setOpenLightBox(true);
    };


    useEffect(() => {
        fetchDetails();
    }, [_id]);

    const fetchDetails = async () => {
        setLoader(true);
        const payload = {
            inquiryId: _id?.id
        };
        try {
            const response = await postRequest(`product/inquiry-detail/admin`, payload);
            const data = response.data;
            setuserAllDetails(data);
            // if(data?.[0]?.userType === 'manufacturer') {
            //     setuserAllDetails(data?.[0].manufacturer);
            // }
            // else if(data?.userType === 'user') {
            //     setuserAllDetails(data?.userDetail);
            // }
            // else if(data?.[0]?.userType === 'deliveryAgent') {
            //     setuserAllDetails(data?.[0].deliveryAgent);
            // }
            setuserTicketData(data);
        } catch (error) {
            console.log("Failed to fetch data:", error);
        } finally {
            setLoader(false);
        }
    };

    const [veriFiedDocument, setveriFiedDocument] = useState([{ documentImage: "" }]);
    const [errors, setErrors] = useState({});
    const [replyTicket, setReplayTicket] = useState('');
    const [loading, setLoading] = useState(false);
    const [isFileSelect, setIsFileSelect] = useState(false);


    const handleClickSupport = (item, newReply) => {
        if (newReply?.reply || newReply?.images?.length > 0) {
            const updatedTicket = {
                ...item,
                replies: [
                    ...(item.replies || []),
                    {
                        images: newReply?.images || [],
                        reply: newReply?.reply,
                        replyBy: newReply?.replyBy,
                        createdAt: newReply?.createdAt,
                    },
                ],
            };
            setuserTicketData(updatedTicket);
            console.log(updatedTicket);
        }
        else {
            setuserTicketData(item);
        }
        // setActiveTicketId(item._id);
        // setCreateNew(false);
        setveriFiedDocument([{ documentImage: "" }]);
    };

    const addReply = async (item) => {
        setLoading(true);
        try {
            let documentImage = '';
            if (isFileSelect) {
                if (item && veriFiedDocument?.[0]?.doc) {
                    const selectedImage = new FormData();
                    selectedImage.append("image", veriFiedDocument[0].doc);
                    const selectedImageUrl = await postRequestForm("image/img/upload", selectedImage);
                    documentImage = selectedImageUrl?.data?.url || '';
                }
            }
            const response = await postRequest('support/reply-add', {
                reply: replyTicket,
                replyBy: 'admin',
                supportTicketId: ticket._id,
                images: isFileSelect ? [documentImage] : []
            });
            if (response.status) {
                setReplayTicket('');
                setveriFiedDocument([{ documentImage: "" }]);
                handleClickSupport(item, response.data);
                setIsFileSelect(false);
            } else {
                setLoading(false);
                console.error("Failed to add reply:", response.data);
            }
        } catch (error) {
            console.error("Error while adding reply to support ticket:", error);
        }
        finally {
            setLoading(false);
        }
    };

    const updateDocument = (key, file) => {
        setIsFileSelect(true);
        const previewUrl = URL.createObjectURL(file);
        const updatedDocuments = veriFiedDocument.map((doc, i) => {
            return { ...doc, [key]: file, previewUrl };
        });
        console.log(updatedDocuments);
        setveriFiedDocument(updatedDocuments);
    }

    const chatContainerRef = useRef(null);
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [ticket?.replies]);

    return (
        <>
            <ToastContainer />
            <Row>
                <Col className="10">
                    <div className="page-title-box">
                        <h4>Inquiry Management</h4>
                        <ol className="breadcrumb m-0">
                            <li className="breadcrumb-item active">Inquiry Management</li>:{" "}
                            <li className="breadcrumb-item">Inquiry Details</li>
                        </ol>
                    </div>
                </Col>
                <div className="col-md-2 text-end">
                    <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        onClick={() => history.back()}
                    >
                        <i class="fas fa-chevron-left"></i> Back
                    </button>
                </div>

                {loader ? (
                    <CardBody style={{ height: "100px" }}>
                        <Spinner
                            color="info"
                            style={{
                                height: "4rem",
                                width: "4rem",
                                position: "absolute",
                                left: "50%",
                            }}
                        >
                            Loading...
                        </Spinner>
                    </CardBody>
                ) : (
                    <>
                        <Card className="custom-card">
                         <div className="d-flex" style={{position : 'relative'}}>

                           <div style={{width : '50%', position : 'relative'}}>
                           <div
                                className="cover-image"
                                style={{ backgroundColor: "rgb(29, 155, 240)" }}
                            ></div>

                            <div className="profile-image">
                                <img
                                    src={
                                        userAllDetails?.userDetail?.photo
                                            ? userAllDetails?.userDetail?.photo
                                            : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.userDetail?.name
                                            }`
                                    }
                                    onClick={() =>
                                        showLightBox(
                                            userAllDetails?.userDetail?.photo
                                                ? userAllDetails?.userDetail?.photo
                                                : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.userDetail?.name
                                                }`
                                        )
                                    }
                                    alt="Image Not Available"
                                />
                            </div>
                            <br></br>

                            <div className="row mt-3 my-2 py-2">
                                <div
                                    className="userinfo col-md-12 "
                                    style={{ paddingLeft: "20px" }}
                                >
                                    <div className="fst">
                                        {" "}
                                        <h3> {userAllDetails?.userDetail?.name} </h3>{" "}
                                    </div>
                                    <div className="row">
                                       
                                        <div className="col-md-12 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                               User Type: <span>User</span>{" "}
                                            </p>{" "}
                                        </div>
                                        <div className="col-md-6 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Email Id: <span>{userAllDetails?.userDetail?.email}</span>{" "}
                                            </p>{" "}
                                        </div>
                                        <div className="col-md-6 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Mobile number: <span> {userAllDetails?.userDetail?.mobile} </span>{" "}
                                            </p>{" "}
                                        </div>

                                        {/* <div className="col-md-4 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Country Code: <span> {userAllDetails?.country_code} </span>{" "}
                                            </p>{" "}
                                        </div> */}

                                        {/* <div className="col-md-4 fst py-1">
                                            <p>
                                                {" "}
                                                Created At:
                                                <span> {formatDate(userAllDetails?.createdAt)}</span>
                                            </p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="border-right" style={{
                                width: 1,
                                background: "#bdbdbd69",
                                padding: 1,
                                position: "absolute",
                                left: 0,
                                height: "100%",
                                right: 84,
                                margin: "auto"
                                }}></div>
                            <div style={{width : '50%', position : 'relative'}}>
                            <div
                                className="cover-image"
                                style={{ backgroundColor: "rgb(29, 155, 240)" }}
                            ></div>
 
                            <div className="profile-image" style={{left : '0'}}>
                                <img
                                    src={
                                        userAllDetails?.manufacturerDetail?.logo
                                            ? userAllDetails?.manufacturerDetail?.logo
                                            : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.manufacturerDetail?.companyName
                                            }`
                                    }
                                    onClick={() =>
                                        showLightBox(
                                            userAllDetails?.manufacturerDetail?.logo
                                                ? userAllDetails?.manufacturerDetail?.logo
                                                : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.manufacturerDetail?.companyName
                                                }`
                                        )
                                    }
                                    alt="Image Not Available"
                                />
                            </div>
                            <br></br>

                            <div className="row mt-3 my-2 py-2">
                                <div
                                    className="userinfo col-md-12 "
                                    style={{ paddingLeft: "20px" }}
                                >
                                    <div className="fst">
                                        {" "}
                                        <h3> {userAllDetails?.manufacturerDetail?.companyName} </h3>{" "}
                                    </div>
                                    <div className="row">
                                       
                                        <div className="col-md-12 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                               User Type: <span>Manufacturer</span>{" "}
                                            </p>{" "}
                                        </div>
                                        <div className="col-md-6 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Email Id: <span>{userAllDetails?.manufacturerDetail?.email}</span>{" "}
                                            </p>{" "}
                                        </div>
                                        <div className="col-md-6 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Mobile number: <span> {userAllDetails?.manufacturerDetail?.mobile} </span>{" "}
                                            </p>{" "}
                                        </div>

                                        {/* <div className="col-md-4 fst py-1">
                                            {" "}
                                            <p>
                                                {" "}
                                                Country Code: <span> {userAllDetails?.country_code} </span>{" "}
                                            </p>{" "}
                                        </div> */}

                                        {/* <div className="col-md-4 fst py-1">
                                            <p>
                                                {" "}
                                                Created At:
                                                <span> {formatDate(userAllDetails?.createdAt)}</span>
                                            </p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>    
                            </div>   
                         
                         </div>
                        </Card>

                        <Col md="12" className="chat-app">

                            <div className="chat" style={{width: '80%'}}>
                                <div className="chat-header clearfix">
                                    <div className="flex-chat-header">
                                        <img
                                            width="90px"
                                            style={{height: '90px',objectFit: "contain",}}
                                            src={ticket?.productDetails?.images?.[0]}
                                            alt="avatar"
                                        />
                                        <div className="chat-about">
                                            <div className="chat-with">
                                                <div className="chat-num-messages">
                                                    <div className="status">
                                                        <h5 className="mb-1">{ticket?.productDetails?.name}</h5>
                                                        <h6 className="mb-1">Quantity : {ticket?.quantity} {ticket?.unit && '/'} {ticket?.unit}</h6>
                                                        <h6 className="mb-1">Message : {ticket?.message} </h6>
                                                        <i className={`${ticket?.status === 'closed' ? 'fa fa-circle offline text-captilise' : 'fa fa-circle online text-captilise'}`} />
                                                        &nbsp;{ticket?.status}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div ref={chatContainerRef} className="chat-history custom-height" style={{ maxHeight: 550 }}>
                                    <ul className="mt-1">

                                        <li classnaxme="clearfix">
                                            <div>
                                                <div className="message-data">
                                                    <span className="message-data-name">
                                                        <i className={`${ticket?.status === 'closed' ? 'offline fa fa-circle ' : 'online fa fa-circle '}`} />
                                                        <b className={`${ticket?.status === 'closed' ? 'offline' : 'online'}`}>&nbsp;User</b><br/>
                                                        &nbsp;
                                                        {userAllDetails?.first_name}&nbsp;{moment(userAllDetails?.createdAt).subtract(0, 'days').calendar()}

                                                    </span>
                                                </div>
                                                <div className="flex-width-image2">

                                                    <div className="message my-message">
                                                        {ticket?.message}
                                                    </div>
                                                   
                                                    {ticket?.images?.[0] && <>
                                                        <div className=" other-message">
                                                            <img src={ticket?.images?.[0]}
                                                                onClick={() =>
                                                                    showLightBox(
                                                                        ticket?.images?.[0])}
                                                            />
                                                        </div>
                                                    </>}
                                                </div>
                                            </div>
                                        </li>

                                        {ticket?.replies?.map((item, index) => {
                                            return (
                                                <>
                                                    {item.type === "manufacturer" ? (
                                                        <li className="">
                                                            <div>
                                                                <div className="message-data align-right"
                                                                    style={{ marginBottom: item?.reply == '' ? '0' : '15px' }}>
                                                                    <span className="message-data-name">
                                                                        <span className={`${ticket?.status === 'closed' ? 'offline' : 'online'}`}>
                                                                         <b>Manufacturer</b><br /></span>
                                                                         <span>{moment(item?.createdAt).subtract(0, 'days').calendar()}</span>
                                                                        &nbsp;
                                                                    </span>
                                                                    
                                                                    <i className={`${ticket?.status === 'closed' ? 'offline fa fa-circle ' : 'online fa fa-circle '}`} />&nbsp;
                                                                </div>
                                                                <div className="flex-width-image">
                                                                    {item?.images?.[0] &&
                                                                        <div className="leftImage other-message float-right">
                                                                            <img src={item?.images?.[0]}
                                                                                onClick={() =>
                                                                                    showLightBox(
                                                                                        item?.images?.[0])}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    {!item?.reply == '' &&
                                                                        <div className="message other-message float-right">
                                                                            {item?.reply}

                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                        </li>
                                                    ) :
                                                        <>
                                                            <li classnaxme="clearfix">
                                                                <div>
                                                                    <div className="message-data">
                                                                        <span className="message-data-name">
                                                                            <i className={`${ticket?.status === 'closed' ? 'offline fa fa-circle ' : 'online fa fa-circle '}`} />&nbsp;
                                                                            <span className={`${ticket?.status === 'closed' ? 'offline' : 'online'}`}>{userAllDetails?.first_name}</span>
                                                                             <b className={`${ticket?.status === 'closed' ? 'offline' : 'online'}`}>User</b>&nbsp;<br/><span>
                                                                                {moment(item?.createdAt).subtract(0, 'days').calendar()}
                                                                            </span>

                                                                        </span>
                                                                    </div>
                                                                    <div className="flex-width-image2">

                                                                        <div className="message my-message">
                                                                            {item?.reply}
                                                                        </div>
                                                                        {item?.images?.[0] && <>
                                                                            <div className=" other-message">
                                                                                <img src={item?.images?.[0]}
                                                                                    onClick={() =>
                                                                                        showLightBox(
                                                                                            item?.images?.[0])}
                                                                                />
                                                                            </div>
                                                                        </>}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </>}
                                                </>
                                            )
                                        })}




                                    </ul>

                                    <div />
                                </div>
                                {ticket?.status !== 'closed' &&
                                    <div className="chat-message clearfix" style={{display : 'none'}}>
                                        <textarea
                                            readOnly={loading}
                                            name="message-to-send"
                                            id="message-to-send"
                                            placeholder="Type your message"
                                            rows={3}
                                            value={replyTicket}
                                            onChange={(e) => setReplayTicket(e.target.value)}
                                        />
                                        {loading ? 
                                            <>
                                            <BeatLoader color="#ffa53b" cssOverride={{
                                                height: '33px', display: 'flex',
                                                alignItems: 'center', justifyContent: 'center'
                                            }} /></>
                                         : <>
                                            <div className="relative">
                                                <div className="chat_upload">
                                                    <label htmlFor="browse" className="">
                                                        <i className="fas solid fa-paperclip" />
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="browse"
                                                        className="form-control"
                                                        name="images"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            if (file) {
                                                                updateDocument("doc", file);
                                                            }
                                                        }}
                                                    />
                                                </div>


                                                <button
                                                    type="submit"
                                                    className="btn btn-animation btn-md fw-bold ms-auto"
                                                    disabled={!replyTicket && !isFileSelect}
                                                    onClick={() => addReply(ticket)} >
                                                    Send
                                                </button>
                                            </div>
                                        
                                        {veriFiedDocument?.[0]?.previewUrl &&
                                            <div className="preview_image">
                                                <img src={veriFiedDocument?.[0]?.previewUrl} />
                                            </div>
                                        }
                                      </>}
                                    </div>
                                }
                            </div>




                        </Col>

                    </>
                )}

                {openLightbox && (
                    <Lightbox
                        mainSrc={imageLB}
                        onCloseRequest={() => setOpenLightBox(false)}
                    />
                )}
            </Row>
            <ToastContainer />{" "}
        </>
    );
}
